import { render, staticRenderFns } from "./CommentManagement.vue?vue&type=template&id=72263396&scoped=true"
import script from "./CommentManagement.vue?vue&type=script&lang=ts"
export * from "./CommentManagement.vue?vue&type=script&lang=ts"
import style0 from "./CommentManagement.vue?vue&type=style&index=0&id=72263396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72263396",
  null
  
)

export default component.exports